export default __webpack_public_path__ + "locales/fi/EmptyTrashDialog.json?hash=45ab0916ce74c504560e3fe80df39bd9";